import EnableAutomaticInvoicingError from './EnableAutomaticInvoicingError';
class InvestorFiscalRegimeDoesNotMatchWithTaxSystem extends EnableAutomaticInvoicingError {
    constructor(options) {
        super('Investor Fiscal Regime Does Not Match With The Tax System', options);
    }
}
export default InvestorFiscalRegimeDoesNotMatchWithTaxSystem;
